import React from 'react';

import {
  ContactsOutlined,
  CreditCardOutlined,
  FileImageOutlined,
  // HomeOutlined,
  InsertRowAboveOutlined,
  LayoutOutlined,
  SettingOutlined,
  ShopOutlined,
  UploadOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { MenuItemType } from 'antd/es/menu/interface';
import { Link, Navigate, Route, Routes } from 'react-router-dom';

import i18n from 'segments/i18n';

import { DashboardLayout } from 'widgets/dashboard-layout';

import Coaches from 'pages/Coaches/Coaches';
import CoachesBooking from 'pages/CoachesBooking/CoachesBooking';
import Config from 'pages/Config/Config';
import Courts from 'pages/Courts/Courts';
import CourtsBooking from 'pages/CourtsBooking/CourtsBooking';
import Groups from 'pages/Groups/Groups';
import ImageStore from 'pages/ImagesStore/ImagesStore';
import Products from 'pages/Products/Products';
import Transactions from 'pages/Transactions/Transactions';
import Users from 'pages/Users/Users';

const menuItems: MenuItemType[] = [
  // {
  //   key: 'home',
  //   icon: <HomeOutlined />,
  //   label: <Link to="/dashboard">{i18n.t('pages.dashboard', 'Главная')}</Link>,
  // },
  {
    key: 'users',
    icon: <UserOutlined />,
    label: <Link to="users">{i18n.t('pages.users', 'Пользователи')}</Link>
  },
  {
    key: 'groups',
    icon: <UsergroupAddOutlined />,
    label: <Link to="groups">{i18n.t('pages.groups', 'Группы')}</Link>
  },
  {
    key: 'courts',
    icon: <CreditCardOutlined />,
    label: <Link to="courts">{i18n.t('pages.courts', 'Коурты')}</Link>
  },
  {
    key: 'coaches',
    icon: <ContactsOutlined />,
    label: <Link to="coahes">{i18n.t('pages.coahes', 'Тренера')}</Link>
  },
  {
    key: 'court-booking',
    icon: <InsertRowAboveOutlined />,
    label: <Link to="/dashboard">{i18n.t('pages.court-booking')}</Link>,
  },
  {
    key: 'coaches-booking',
    icon: <LayoutOutlined />,
    label: <Link to="coaches-booking">{i18n.t('pages.coaches-booking')}</Link>,
  },
  {
    key: 'products',
    icon: <ShopOutlined />,
    label: <Link to="products">{i18n.t('pages.products', 'Продукты')}</Link>
  },
  {
    key: 'config',
    icon: <SettingOutlined />,
    label: <Link to="config">{i18n.t('pages.config', 'Конфиг')}</Link>,
  },
  {
    key: 'transactions',
    icon: <UploadOutlined />,
    label: <Link to="transactions">{i18n.t('pages.transactions', 'Транзакции')}</Link>,
  },
  {
    key: 'images',
    icon: <FileImageOutlined />,
    label: <Link to="images">{i18n.t('pages.images', 'Изоброжения')}</Link>,
  }
];

const DashboardAdmin = () => (
  <DashboardLayout sideMenu={menuItems}>
    <Routes>
      <Route path="users" element={<Users />} />
      <Route path="courts" element={<Courts />} />
      <Route path="groups" element={<Groups />} />
      <Route path="coahes" element={<Coaches />} />
      <Route path="images" element={<ImageStore />} />
      <Route index element={<CourtsBooking />} />
      <Route path="coaches-booking" element={<CoachesBooking />} />
      <Route path="products" element={<Products />} />
      <Route path="config" element={<Config />} />
      <Route path='transactions' element={<Transactions />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  </DashboardLayout>
);

export default DashboardAdmin;
